<template>
    <v-container>
        <v-layout row wrap class="feed">
            <v-flex xs12>
                <h2> PUBLICAÇÕES</h2>
                <div class="risquinho"></div>
                <Posts :postKey="postKey" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Posts from '../components/Posts'

export default {
    props: ['postKey'],
    components: { Posts },
    data() {
        return {
        }
    },

    created(){
        // this.get()
    },

    methods: {
        
    }
}
</script>

<style>

</style>
